import { useEffect, useState } from "react"
import Modal from 'react-bootstrap/Modal';
import AmountModeField from "../common/AmountModeField";
import { CheckNull, CurrencyConvertion, isNumberOnly, PriceCheck, QatarConvertion, calculateNetPrice } from "../../utils/Validate";
import { buildColorChargeRows, sumColorChargeAmounts } from "../../utils/colorCharges";

export const QuotationSummary = ({ values, setValues, FormatValueDecimal, currencyList, currencyDetail, qarCurrencyDetail, editQuotation, setQuotUserEntry,
    quotUserEntry }) => {
    const [quotationSummary, setQuotationSummary] = useState({});
    const [specialColorModalShow, setSpecialColorModalShow] = useState(false);


    const [taxMode, setTaxMode] = useState('$');
    const [customDutyMode, setCustomDutyMode] = useState('$');
    const [clearnceMode, setClearnceMode] = useState('$');
    const [typedAmounts, setTypedAmounts] = useState({});

    const HandleCustomDutyModeChange = () => {
        setCustomDutyMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, customDutyPercentage: 0, customDuty: 0 })
    };

    const HandleClearnceModeChange = () => {
        setClearnceMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, clearanceChargesPercentage: 0, clearanceCharges: 0 })
    };

    const HandleTaxModeChange = () => {
        setTaxMode((prevMode) => (prevMode === '$' ? '%' : '$'));
        setQuotUserEntry({ ...quotUserEntry, tax: 0, taxPercentage: 0 })
    };

    useEffect(() => {
        let totListPrice = 0;
        let totNetPrice = 0;

        values?.products?.forEach((item) => {
            const listPrice = parseFloat(item?.listPrice);
            const safeListPrice = isNaN(listPrice) ? 0 : listPrice;

            totListPrice += safeListPrice;
            totNetPrice += calculateNetPrice(item);
        });

        setQuotationSummary({
            ...quotationSummary,
            totalListPrice: totListPrice,
            netPrice: totNetPrice,
        });
    }, [values?.products]);

    useEffect(() => {
        const newValues = {
            ...values,
            totalListPrice: quotationSummary?.totalListPrice,
            netPrice: quotationSummary?.netPrice,
        };
        setValues(newValues);
    }, [quotationSummary]);

    const calculateTotalDdp = (item, freightCustoms) => {
        const sellingPrice = calculateNetPrice(item);

        if (freightCustoms >= 1) return 0;

        const ddpMultiplier = 1 - freightCustoms;

        const finalDdp = sellingPrice / (ddpMultiplier || 1);

        if (!Number.isFinite(finalDdp)) return 0;

        return finalDdp.toFixed(2);
    };

    useEffect(() => {
        const totalExworksPrice = (values?.netPrice * 1) + (values.specialCharges * 1)
        const customDutyValue = customDutyMode === '$' ? (values?.customDuty * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1)) * ((values?.customDutyPercentage * 1) / 100))
        const clearnceValue = clearnceMode === '$' ? (values?.clearanceCharges * 1) : (((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1)) * ((values?.clearanceChargesPercentage * 1) / 100))
        const totalLandedCost = ((totalExworksPrice * 1) + (values?.freightCharges * 1) + (customDutyValue * 1) + (clearnceValue * 1))
        // const salesMarginValue = ((totalLandedCost * 1) / (1 - (values?.salesMarginPercentage / 100)))
        const salesMarginValue = totalLandedCost * 1
        const taxValue = taxMode === '$' ? (values?.tax * 1) : ((salesMarginValue * 1) * ((values?.taxPercentage * 1) / 100))
        // const taxValue = taxMode === '$' ? (values?.tax * 1) : ((values?.taxPercentage * 1) / 100)
        const grandTotal = taxValue + salesMarginValue
        // const frieghtcustoms = (totalLandedCost - (values?.netPrice * 1))
        // Special colour is a quotation-level charge.  It belongs in the
        // commercial summary, but must not be distributed into every product's
        // Total DDP value.
        const productLandedCost = Math.max(
            0,
            totalLandedCost - (Number(values?.specialCharges) || 0)
        );
        const freightCustoms = productLandedCost > 0
            ? (productLandedCost - (Number(values?.netPrice) || 0)) / productLandedCost
            : 0;

        const productsArr = values?.products?.map((item) => {
            const totalDdp = calculateTotalDdp(item, freightCustoms);
            return { ...item, totalDdp };
        });

        setValues((prev) => ({
            ...prev,
            products: productsArr,
            totalSellingPrice: parseFloat(salesMarginValue),
            totalExworksPrice: parseFloat(totalExworksPrice),
            grandTotal: parseFloat(grandTotal),
            totalLandedCost: parseFloat(totalLandedCost),
        }));
    }, [
        values?.specialCharges,
        values?.netPrice,
        values?.customDuty,
        values?.customDutyPercentage,
        values?.freightCharges,
        values?.clearanceCharges,
        values?.clearanceChargesPercentage,
        // values?.salesMarginPercentage,
        values?.tax,
        values?.taxPercentage,
        clearnceMode, customDutyMode, taxMode
    ]);

    useEffect(() => {
        if (values?.customDuty > 0) setCustomDutyMode('$')
        else setCustomDutyMode('%')
        if (values?.tax > 0) setTaxMode('$')
        else setTaxMode('%')
        if (values?.clearanceCharges > 0) setClearnceMode('$')
        else setClearnceMode('%')
    }, [values.id])

    const HandleInputChange = (e) => {
        const { name, value } = e.target;
        setQuotUserEntry({ ...quotUserEntry, [name]: value || 0 })
    }
    const conversionRateValue = Number(values?.conversionRate) || 1;
    const amountFields = ["freightCharges", "customDuty", "clearanceCharges", "tax"];

    const HandleCurrencyInputChange = (e) => {
        const { name, value } = e.target;
        if (!amountFields.includes(name)) {
            HandleInputChange(e);
            return;
        }
        setTypedAmounts((prev) => ({ ...prev, [name]: value }));
        const enteredValue = value === "" ? 0 : Number(value);
        setQuotUserEntry({ ...quotUserEntry, [name]: enteredValue });
    };

    const toDisplayAmount = (amount) =>
        Number(amount) > 0 ? Number(Number(amount).toFixed(2)) : "";

    const displayAmount = (name, qarAmount) =>
        typedAmounts[name] !== undefined ? typedAmounts[name] : toDisplayAmount(qarAmount);

    useEffect(() => {
        setTypedAmounts({});
    }, [values?.conversionRate, values?.id, customDutyMode, clearnceMode, taxMode]);


    const specialChargeKey = (row, index) => `special-${row?.colorCode || index}`;

    const displaySpecialCharge = (row, index) => {
        const typed = typedAmounts[specialChargeKey(row, index)];
        if (typed !== undefined) return typed;
        const amount = row?.chargeAmount;
        if (amount === undefined || amount === null || amount === "") return "";
        return Number(Number(amount).toFixed(2));
    };

    useEffect(() => {
        if (specialColorModalShow) return;
        setTypedAmounts((prev) => {
            const next = { ...prev };
            Object.keys(next).forEach((key) => {
                if (key.startsWith("special-")) delete next[key];
            });
            return next;
        });
    }, [specialColorModalShow]);

    const specialColorRows = buildColorChargeRows(values);
    const hasSpecialColorReview = specialColorRows.some((row) =>
        Boolean(row?.needsReviewCharge || row?.needsChargeReview)
    );

    useEffect(() => {
        if (!Array.isArray(values?.colorCharges)) return;
        const totalCharges = sumColorChargeAmounts(values.colorCharges);
        setQuotUserEntry((previous) => (
            Number(previous?.specialCharges) === totalCharges
                ? previous
                : { ...previous, specialCharges: totalCharges }
        ));
    }, [values?.colorCharges]);

    const HandleSpecialColorChargeChange = (row, field, value, index) => {
        const numericFields = ["chargeAmount"];
        const isNumericField = numericFields.includes(field);
        const typedNumber = isNumericField ? (value === "" ? 0 : Number(value)) : value;

        if (isNumericField && (!Number.isFinite(typedNumber) || typedNumber < 0)) return;

        if (isNumericField) {
            setTypedAmounts((prev) => ({ ...prev, [specialChargeKey(row, index)]: value }));
        }
        const nextValue = isNumericField
            ? Number(typedNumber.toFixed(2))
            : typedNumber;

        // The special-colour write model contains only the approved charge.
        const updatedCharges = specialColorRows.filter((currentRow) => currentRow?.isChargeable).map((currentRow) => {
            const charge = {
                id: currentRow?.id,
                colorCode: currentRow?.colorCode,
                chargeAmount: Number(currentRow?.chargeAmount) || 0,
            };

            return currentRow?.colorCode === row?.colorCode
                ? { ...charge, [field]: nextValue }
                : charge;
        });
        const totalCharges = sumColorChargeAmounts(updatedCharges);
        const updatedColorAreaSummary = specialColorRows.map((currentRow) => ({
            ...currentRow,
            chargeAmount: currentRow?.colorCode === row?.colorCode
                ? nextValue
                : Number(currentRow?.chargeAmount) || 0,
        }));

        setValues((previous) => ({
            ...previous,
            colorAreaSummary: updatedColorAreaSummary,
            colorCharges: updatedCharges,
            colorChargesTouched: true,
        }));
        setQuotUserEntry((previous) => ({ ...previous, specialCharges: totalCharges }));
    };

    const formatSurfaceArea = (value) => {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return "0 m²";
        return `${FormatValueDecimal(numericValue)} m²`;
        // return `${FormatValueDecimal(numericValue)}`;
    };

    useEffect(() => {
        setValues((prev) => ({
            ...prev,
            specialCharges: Number(quotUserEntry?.specialCharges) || 0,
            freightCharges: Number(quotUserEntry?.freightCharges) || 0,
            customDuty: Number(quotUserEntry?.customDuty) || 0,
            customDutyPercentage: Number(quotUserEntry?.customDutyPercentage) || 0,
            clearanceCharges: Number(quotUserEntry?.clearanceCharges) || 0,
            clearanceChargesPercentage: Number(quotUserEntry?.clearanceChargesPercentage) || 0,
            tax: Number(quotUserEntry?.tax) || 0,
            taxPercentage: Number(quotUserEntry?.taxPercentage) || 0,
        }));
    }, [quotUserEntry]);

    useEffect(() => {
        const baseCode = qarCurrencyDetail?.shortCode;
        if (!baseCode) return;

        setValues((prev) => ({
            ...prev,
            specialCharges: Number(quotUserEntry?.specialCharges) || 0,
            freightCharges: Number(quotUserEntry?.freightCharges) || 0,
            customDuty: Number(quotUserEntry?.customDuty) || 0,
            clearanceCharges: Number(quotUserEntry?.clearanceCharges) || 0,
            tax: Number(quotUserEntry?.tax) || 0,
        }));
    }, [quotUserEntry, qarCurrencyDetail?.shortCode])

    const quoteCurrency =
        currencyList?.find((item) => item?.id === values?.currencyId) || currencyDetail;


    return (
        <div className="card quotation-commercial-summary">
            <div className="card-header">
                <h5>{qarCurrencyDetail?.shortCode} : {FormatValueDecimal(QatarConvertion(values?.grandTotal, values?.conversionRate, quoteCurrency))}</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="mb-2">
                            <label>Net price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="netPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(values?.netPrice)}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <label className="mr-1">Special color</label>

                                    <button
                                        type="button"
                                        className="btn p-0 mb-1"
                                        aria-label="Open special color details"
                                        onClick={() => setSpecialColorModalShow(true)}
                                    >
                                        <i className="fas fa-angle-right"></i>
                                    </button>
                                </div>
                                {hasSpecialColorReview && (
                                    <i
                                        className="fas fa-exclamation-triangle text-warning mr-1 mb-2"
                                        title="Special color charge needs review"
                                        aria-label="Special color charge needs review"
                                    ></i>
                                )}
                            </div>
                            <input
                                autoComplete="off"
                                type="number"
                                name="specialCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                value={quotUserEntry.specialCharges > 0 ? Number(quotUserEntry.specialCharges).toFixed(2) : ""}
                                disabled
                                style={{ textAlign: "right" }}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Ex-Works price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalExworksPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(values?.totalExworksPrice)}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Frieght & delivery charges</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="freightCharges"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleCurrencyInputChange}
                                value={displayAmount("freightCharges", quotUserEntry?.freightCharges)}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Custom Duty</label>
                            <AmountModeField
                                min="0"
                                mode={customDutyMode}
                                name={customDutyMode === '$' ? 'customDuty' : 'customDutyPercentage'}
                                onChange={HandleCurrencyInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleCustomDutyModeChange}
                                step=".01"
                                value={customDutyMode === '$' ? displayAmount("customDuty", quotUserEntry?.customDuty) :
                                    quotUserEntry?.customDutyPercentage > 0 ? quotUserEntry?.customDutyPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Clearance charges</label>
                            <AmountModeField
                                min="0"
                                mode={clearnceMode}
                                name={clearnceMode === '$' ? 'clearanceCharges' : 'clearanceChargesPercentage'}
                                onChange={HandleCurrencyInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleClearnceModeChange}
                                step=".01"
                                value={clearnceMode === '$' ? displayAmount("clearanceCharges", quotUserEntry?.clearanceCharges) :
                                    quotUserEntry?.clearanceChargesPercentage > 0 ? quotUserEntry?.clearanceChargesPercentage : ""}
                            />
                        </div>
                        <div className="mb-2">
                            <label>Total Landed Cost</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="totalLandedCost"
                                disabled="true"
                                value={values?.totalLandedCost > 0 ? FormatValueDecimal(values?.totalLandedCost) : 0}
                                style={{ textAlign: "right" }}
                            // onChange={HandleInputChange}
                            ></input>
                        </div>
                        {/* <div className="mb-2">
                            <label>Sales Margin (%)</label>
                            <input
                                autocomplete="off"
                                type="number"
                                name="salesMarginPercentage"
                                step=".01"
                                min="0"
                                className="form-control"
                                placeholder="Enter"
                                onChange={HandleInputChange}
                                value={quotUserEntry?.salesMarginPercentage > 0 ? quotUserEntry?.salesMarginPercentage : ""}
                                onkeypress={(e) => { return PriceCheck(e.target.value) }}
                                style={{ textAlign: "right" }}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                            />
                        </div> */}
                        <div className="mb-2">
                            <label>Total Selling Price</label>
                            <input
                                className="form-control"
                                type="text"
                                name="totalSellingPrice"
                                placeholder="Enter"
                                value={FormatValueDecimal(values?.totalSellingPrice)}
                                disabled="true"
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                        <div className="mb-2">
                            <label>Tax</label>
                            <AmountModeField
                                min="0"
                                mode={taxMode}
                                name={taxMode === '$' ? 'tax' : 'taxPercentage'}
                                onChange={HandleCurrencyInputChange}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                onModeToggle={HandleTaxModeChange}
                                step=".01"
                                value={taxMode === '$' ? displayAmount("tax", quotUserEntry?.tax) :
                                    quotUserEntry?.taxPercentage > 0 ? quotUserEntry?.taxPercentage : ""}
                            />
                        </div>
                        <div className="mb-0 quotation-grand-total-field">
                            <label>
                                Grand Total{quoteCurrency?.shortCode ? ` (${quoteCurrency.shortCode})` : ""}
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter"
                                name="grandTotal"
                                disabled="true"
                                value={values?.grandTotal > 0 ? FormatValueDecimal(values?.grandTotal) : 0}
                                style={{ textAlign: "right" }}
                            ></input>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="lg"
                show={specialColorModalShow}
                onHide={() => setSpecialColorModalShow(false)}
                className="special-color-modal-popup drawer right-align"
            >
                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h5 className="mb-0">Special Color</h5>
                        <i className="fas fa-times" onClick={() => setSpecialColorModalShow(false)}></i>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>RAL Color Code</th>
                                    {/* <th>Powder Area</th> */}
                                    <th>Total Surface Area (m²)</th>
                                    <th>Charges ({quoteCurrency?.shortCode})</th>
                                </tr>
                            </thead>
                            <tbody>
                                {specialColorRows?.length > 0 ? (
                                    specialColorRows.map((row, index) => (
                                        <tr key={row.colorCode || index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {row.colorCode || "Unassigned"}
                                            </td>
                                            <td>{row.knownAreaSquareMetres === null || row.knownAreaSquareMetres === undefined ? "Pending calculation" : formatSurfaceArea(row.knownAreaSquareMetres)}</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    name={`specialColorCharge-${row.colorCode || index}`}
                                                    step=".01"
                                                    min="0"
                                                    className="form-control"
                                                    placeholder="Enter"
                                                    disabled={!row.isChargeable}
                                                    onChange={(e) => HandleSpecialColorChargeChange(row, "chargeAmount", e.target.value, index)}
                                                    value={displaySpecialCharge(row, index)}
                                                    onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                                                    style={{ textAlign: "right" }}
                                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No special color details available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn save-btn" type="button" onClick={() => setSpecialColorModalShow(false)}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

